// PANTALLA 1 — El Gran Objetivo (Documento Maestro v2.2, §1) [ACTUALIZADO v2.1]
//
// Cambio de v2: además de las 4 tarjetas, hay una 5ª opción de TEXTO LIBRE.
// El texto escrito se guarda en `aspiration_custom` y la Pantalla 7 lo usa
// literalmente en el copy del plan ("Tu ruta hacia [aspiration]").
import { useState } from 'react';
import OptionCards, { MicroReaction } from './OptionCards';
import { SCREEN1_HEADLINE, ASPIRATIONS, CUSTOM_OPTION } from './onboardingContent';
import { etiquetaDePaso } from './pasos';

export default function Screen1_Identidad({ value, customValue, onAnswer, onNext }) {
  const [selected, setSelected] = useState(value ?? null);
  const [custom, setCustom] = useState(customValue ?? '');

  const chosen = ASPIRATIONS.find((a) => a.value === selected);
  const isCustom = selected === CUSTOM_OPTION;

  const handleSelect = (v) => {
    setSelected(v);
    // Al cambiar a una opción normal se limpia el texto libre: dejarlo colgado
    // haría que la Pantalla 7 hablara de una meta que el usuario ya descartó.
    const nextCustom = v === CUSTOM_OPTION ? custom : '';
    if (v !== CUSTOM_OPTION) setCustom('');
    onAnswer({ aspiration: v, aspiration_custom: nextCustom || null });
  };

  const handleCustomChange = (text) => {
    setCustom(text);
    onAnswer({ aspiration: CUSTOM_OPTION, aspiration_custom: text || null });
  };

  // La opción libre exige texto: sin él, el plan final quedaría sin objetivo.
  const canContinue = Boolean(chosen) && (!isCustom || custom.trim().length > 0);

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">{etiquetaDePaso(1)}</p>
      <h1 className="ob-headline">
        <span className="ob-headline-linea">{SCREEN1_HEADLINE.linea}</span>
        <span className="ob-bloque">{SCREEN1_HEADLINE.bloque}</span>
      </h1>

      <OptionCards
        options={ASPIRATIONS}
        selected={selected}
        onSelect={handleSelect}
        customValue={custom}
        onCustomChange={handleCustomChange}
      />

      <MicroReaction text={chosen?.reaction} />

      {canContinue && (
        <div className="ob-actions">
          <button type="button" className="ob-btn" onClick={onNext}>
            Continuar →
          </button>
        </div>
      )}
    </div>
  );
}
